export default function Logic(props) {
  // prevent creating a Children sub-path
  return props.children
}
